<template>
	<div class="Seekinsurance">
		<div class="partOne">
			<div class="inner-box">
				<div class="mshcn">
					<div class="dot"></div>
					<div class="txt">61MSH.COM</div>
				</div>
				<div class="mshcnkj">谋生活零工保</div>
				<div class="item"><span>➣</span>零工保 保灵工<span
						style="color: #6d758a;margin-left: 3%;">灵活就业者风险保障的安全卫士</span></div>
				<div class="item"><span>➣</span>零工保<span
						style="color: #6d758a;margin-left: 7.3%;">灵活就业者工作与生活的安全守护者</span></div>
				<div class="item"><span>➣</span>零工保<span style="color: #6d758a;margin-left: 7.4%;">灵活用工，马上就保</span>
				</div>
				<div class="item"><span style="color: #6d758a;margin-left: 12.5%;">灵活性高，按天投保</span></div>
				<div class="imgBox">
					<img alt="" src="../assets/images/lgb.png" width="400" height="400">
				</div>
			</div>
		</div>
		<div class="textcenter">
			<div class="tc-phone">
				<div style="margin: 0 15px;"><i class="fa fa-phone" style="font-size: 25px;font-style: normal;"></i>
				</div>
				<span>400-700-9161</span>
			</div>
			<h3>
				灵活就业及企业用工灵活化服务SaaS服务平台
			</h3>
		</div>
		<div class="partTwo">
			<div class="inner-box">
				<div>
					<h4>众多企业遇到的问题</h4>
				</div>
				<div class="bb">
					<div class="ll">
						<div class="item1 flex-center-center">
							<div class="img">
								<img alt="" src="../assets/fxwcbz.png" width="80">
								<div class="txt">风险无处不在</div>
							</div>
							<div class="itemActive">
								<div class="txt1">风险无处不在</div>
								<div class="txt2">除了部分职业自带的风险外，工伤范围还包括通勤途中等时段</div>
							</div>
						</div>
					</div>
					<div class="rr">
						<div class="item2 flex-center-center">
							<div class="img">
								<img alt="" src="../assets/bjga.png" width="80">
								<div class="txt">商保报价高昂</div>
							</div>
							<div class="itemActive">
								<div class="txt1">商保报价高昂</div>
								<div class="txt2">商业保险价格和员工数、员工年龄、所处行业、工作性质等因素相关，企业单独向保险公司购买，难以享受团体价</div>
							</div>
						</div>
						<div class="item3 flex-center-center">
							<div class="img">
								<img alt="" src="../assets/be.png" width="80">
								<div class="txt">赔付保额不高</div>
							</div>
							<div class="itemActive">
								<div class="txt1">赔付保额不高</div>
								<div class="txt2">不少商业保险的保额不高，仍难以补足员工发生意外后的各种支出</div>
							</div>
						</div>
						<div class="item4 flex-center-center">
							<div class="img">
								<img alt="" src="../assets/cblc.png" width="80">
								<div class="txt">参保流程复杂</div>
							</div>
							<div class="itemActive">
								<div class="txt1">参保流程复杂</div>
								<div class="txt2">对大中型企业来说，员工基数大，入离职频繁，每月调整参保名单，需要耗费HR不少精力</div>
							</div>
						</div>
						<div class="item5 flex-center-center">
							<div class="img">
								<img alt="" src="../assets/ygxq.png" width="80">
								<div class="txt">员工需求迫切</div>
							</div>
							<div class="itemActive">
								<div class="txt1">员工需求迫切</div>
								<div class="txt2">超过50%的希望在企业福利制度中增添补充商业保险</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="partThree">
			<div class="inner-box">
				<div>
					<h4>我们能解决什么？</h4>
				</div>
				<div class="bb">
					<div class="ll">
						<img src="../assets/images/linggongbao.png" height="506">
					</div>
					<div class="rr">
						<div class="item">
							<div class="title">
								<span>➣</span>
								<div>保障范围广</div>
							</div>
							<div class="content">可为 1 ～ 4 类人群提供在工作期间发生的工伤意外及医疗保障，为灵工提供多重生活与工作风险保障</div>
						</div>
						<div class="item">
							<div class="title">
								<span>➣</span>
								<div>伤残赔付/医疗费用保额高</div>
							</div>
							<div class="content">灵活就业者因工伤、意外导致的医疗费用可直接报销，给灵工提供更充分的保障</div>
						</div>
						<div class="item">
							<div class="title">
								<span>➣</span>
								<div>理赔快、门槛低</div>
							</div>
							<div class="content">工伤意外等鉴定材料提供齐全后，7个工作日内完成赔付过程，理赔速速快切赔付门槛低</div>
						</div>
						<div class="item">
							<div class="title">
								<span>➣</span>
								<div>灵活性高</div>
							</div>
							<div class="content">我们可为灵活性用工企业或平台中灵活就业者的风险保障，及转嫁灵活就业者在工作中的用工风险责任，当天投保即可生效</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<my-footer></my-footer>
	</div>
</template>

<script>
	export default {
		name: 'Seekinsurance',
		created() {

		},
		methods: {

		}
	}
</script>

<style scoped>
	@font-face {
		font-family: "frozen";
		src: url("https://s3-us-west-2.amazonaws.com/s.cdpn.io/209981/Ice%20kingdom%20-%20Bold%20-%20Por%20Kustren.woff");
	}

	.Seekinsurance {
		background-color: rgb(255, 255, 255);
		height: 100%;
		/* margin-top: 50px; */
	}

	.partOne {
		height: 335px;
		background-color: #f9fafc;
		position: relative;
		/* margin: 0 0 2%; */
		padding-top: 6%;
	}

	.partOne .mshcn {
		margin-left: 11%;
		margin-bottom: 15px;
		display: flex;
		align-items: center;
	}

	.partOne .mshcn .dot {
		width: 12px;
		height: 12px;
		background-color: #ff8400;
		border-radius: 50%;
		margin-right: 10px;
	}

	.partOne .mshcn .txt {
		width: 84px;
		height: 20px;
		font-family: "frozen", serif;
		font-size: 18px;
		color: #ff8400;
		font-weight: 700;
	}

	.partOne .mshcnkj {
		margin-left: 11%;
		font-size: 40px;
		color: #0d1d34;
		font-weight: 600;
		position: relative;
		margin-bottom: 50px;
	}

	.partOne .mshcnkj::before {
		content: "";
		width: 104px;
		height: 2px;
		background-color: #e6e6e6;
		position: absolute;
		left: 70px;
		bottom: -15px;
	}

	.partOne .mshcnkj::after {
		content: "";
		width: 70px;
		height: 4px;
		background: #ff8500;
		border-radius: 2px;
		position: absolute;
		left: 0px;
		bottom: -16px;
	}

	.partOne .item {
		margin-left: 11%;
		display: flex;
		align-items: center;
		line-height: 40px;
		font-size: 14px;
		color: #1c1c1c;
		font-weight: 400;
	}

	.partOne .imgBox {
		position: absolute;
		right: 0;
		top: -6%;
		margin-top: -5%;
		animation: contentFromRight2Left .6s ease-out;
	}

	.textcenter {
		background-color: #ff8400;
		color: #fff;
		text-align: center;
		padding: 20px 0 20px;
		border: 1px solid #eff2f8;
		/* background: url(../views/svg.png) no-repeat center; */
	}

	.textcenter .tc-phone {
		margin: 20px 0;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.textcenter .tc-phone span {
		font-size: 28px;
		/* font-family: "frozen", serif; */
		/* font-family: PingFangSC-Medium, PingFang SC; */
		font-weight: 500;
		/* color: #ffffff; */
		line-height: 40px;
	}

	.textcenter h3 {
		margin: 20px 0;
		font-size: 28px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		/* color: #ffffff; */
		line-height: 45px;
	}

	h4 {
		font-size: 34px;
		/* font-family: PingFangSC-Medium, PingFang SC; */
		font-weight: 500;
		color: #222426;
		line-height: 48px;
		text-align: center;
	}

	.partTwo {
		height: 640px;
		/* background-color: #f9fafc; */
		margin-top: 5%;
	}

	.partTwo .bb {
		display: flex;
		align-items: center;
		margin-top: 50px;
	}

	.partTwo .bb .ll {
		width: 380px;
	}

	.partTwo .rr {
		width: 790px;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
	}

	.partTwo .bb .ll .item1 {
		width: 360px;
		height: 480px;
		flex-direction: column;
	}

	.partTwo .bb .rr .item2,
	.partTwo .bb .rr .item4 {
		width: 460px;
		height: 210px;
		background: #fff;
		flex-direction: column;
		margin-top: 30px;
	}

	.partTwo .bb .rr .item3,
	.partTwo .bb .rr .item5 {
		width: 300px;
		height: 210px;
		border-radius: 10px;
		flex-direction: column;
		margin-top: 30px;
	}

	.partTwo .item1 .txt {
		margin-top: 30px;
	}

	.partTwo .txt {
		font-size: 16px;
		color: #1c1c1c;
		text-align: center;
		font-weight: 600;
	}

	.partTwo .item1,
	.partTwo .item2,
	.partTwo .item3,
	.partTwo .item4,
	.partTwo .item5 {
		position: relative;
		border-radius: 10px;
		background-color: #fff;
		box-shadow: 0 10px 10px 0 #eff2f8;
	}

	.flex-center-center {
		display: flex;
		align-items: center;
	}

	.flex-center-center,
	.jc {
		justify-content: center;
	}

	.partTwo .item1 .itemActive {
		width: 360px;
		height: 300px;
		background: #ff8500;
		border-radius: 10px;
		-ms-flex-direction: column;
		flex-direction: column;
		padding-top: 50%;
		position: absolute;
		transform: rotatey(90deg);
	}

	.partTwo .item2 .itemActive,
	.partTwo .item4 .itemActive {
		width: 460px;
		height: 115px;
		background: #ff8500;
		border-radius: 10px;
		-ms-flex-direction: column;
		flex-direction: column-reverse;
		padding-top: 1%;
		position: absolute;
		transform: rotatey(90deg);
		padding-top: 22%;
		padding: 16% 0px;
	}

	.partTwo .item3 .itemActive,
	.partTwo .item5 .itemActive {
		width: 300px;
		height: 149px;
		background: #ff8500;
		border-radius: 10px;
		-ms-flex-direction: column;
		flex-direction: column;
		padding-top: 30%;
		position: absolute;
		transform: rotatey(90deg);
	}

	.partTwo .flex-center-center:hover .img {
		transform: rotatey(90deg);
		transition: .5s;
	}

	.partTwo .flex-center-center:hover .itemActive {
		transform: rotatey(0deg);
		transition: .7s;
	}

	.partTwo .txt1 {
		font-size: 16px;
		color: #fff;
		text-align: center;
		font-weight: 600;
	}

	.partTwo .txt2 {
		font-size: 14px;
		color: #fff;
		text-align: center;
		line-height: 30px;
		font-weight: 400;
	}

	.partThree {
		height: 700px;
		padding-top: 35px;
	}
	.partThree .bb{
		margin-top: 68px;
	}
	.partThree .bb .ll {
		width: 560px;
		height: 506px;
		position: absolute;
		left: 0;
		top: 17%;
	}

	.partThree .bb .rr {
		width: 500px;
		margin-left: 650px;
		height: 506px;
	}
	 .partThree .bb .rr .item {
	  padding: 30px;
	  position: relative;
	  box-shadow: 0 10px 10px 0 #eff2f8;
	  border-radius: 4px;
	  margin-bottom: 20px;
	  cursor: pointer;
	  border-left: 4px solid transparent;
	  box-sizing: border-box;
	}
	.partThree .bb .rr .item .title {
	  font-size: 16px;
	  color: #1c1c1c;
	  /* line-height: 22px; */
	  font-weight: 600;
	  display: flex;
	  align-items: center;
	  /* margin-bottom: 20px; */
	}
	.partThree .bb .rr .item .content{
		position: absolute;
		transform: rotatey(90deg);
	}
	
	.partThree .bb .rr .item:hover{
		height:150px;
		border-left:6px solid #FF8500;
	}
	.partThree .bb .rr .item:hover .content {
	  font-size: 14px;
	  color: #6d758a;
	  line-height: 30px;
	  font-weight: 400;
	  transform: rotatey(0deg);
	  transition: .7s;
	}
	
	.partThree .bb .rr .item:hover .title{
		color:#ff8500;
		margin-bottom: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/page/Seekinsurance.vue